import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Col, Container, Row, Accordion } from "react-bootstrap";
import "./CourseDetail.css";
import PaymentButton from "../components/PaymentButton";

import javaImg from "../assets/java.jpeg";
import pythonImg from "../assets/python.jpg";
import mernImg from "../assets/Mern.png";
import uiuxImg from "../assets/uiux.jpg";
import autocadImg from "../assets/Autocad.jpg";
import dataanalyticsImg from "../assets/dataanalytics.jpeg";
import digitalmarketingImg from "../assets/digitalmarketing.jpeg";
import cloudcomputingImg from "../assets/cloud.jpeg";
import dsaImg from "../assets/dsa.jpg";
import datascienceImg from "../assets/datascience.jpg";
import aimlImg from "../assets/aiml.jpg";
import appdevelopmentImg from "../assets/appdevelopment.png";

// =======================
//  ALL COURSE DATA HERE
// =======================
const courseData = {
  java: {
    title: "Java Full Stack Development",
    desc: "Learn to build powerful and scalable web applications using Java, Spring Boot, React.js, and MongoDB.",
    bannerImg: require("../assets/java.jpeg"),

    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "📅 Duration: 120+ Hours of Learning",
      "💻 5 Real-world Industry Projects",
      "📝 Hands-on Labs & Assignments",
      "🌐 Frontend + Backend + Database Coverage",
      "🎓 Certification upon Completion",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],
    roadmap: [
      {
        title: "Module 1: Core Java",
        content:
          "Java basics, OOPs concepts, Collections, Exception handling, Streams, and Multithreading.",
      },
      {
        title: "Module 2: Advanced Java & Spring Boot",
        content:
          "JDBC, Servlets, JSP, Spring Boot, REST APIs, Hibernate, and Microservices.",
      },
      {
        title: "Module 3: Frontend Development",
        content:
          "HTML, CSS, JavaScript, React.js, State Management, and UI/UX best practices.",
      },
      {
        title: "Module 4: Database & Deployment",
        content:
          "MySQL, MongoDB, Cloud Deployment (AWS/Heroku), Docker basics, CI/CD pipeline.",
      },
      {
        title: "Capstone Project",
        content:
          "End-to-End Full Stack Project integrating Java backend with React.js frontend and database.",
      },
    ],
  },

  python: {
    title: "Python Full Stack Development",
    desc: "Master Python for full stack web development, data handling, and API building using Django and React.",
    bannerImg: require("../assets/python.jpg"),
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "📅 Duration: 100+ Hours of Learning",
      "💻 4 Real-world Projects",
      "⚙️ Backend with Django & REST APIs",
      "🌐 Frontend with React.js",
      "🎓 Certification upon Completion",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],
    roadmap: [
      {
        title: "Module 1: Python Fundamentals",
        content: "Syntax, Functions, OOPs, Exception Handling, and Modules.",
      },
      {
        title: "Module 2: Django Framework",
        content: "MVC architecture, ORM, Templates, Authentication, REST APIs.",
      },
      {
        title: "Module 3: Frontend Development",
        content:
          "HTML, CSS, React.js, State management, and Integration with APIs.",
      },
      {
        title: "Module 4: Database & Deployment",
        content: "SQLite, PostgreSQL, AWS/Heroku deployment, Docker basics.",
      },
      {
        title: "Capstone Project",
        content:
          "Build a complete Django + React full stack project with authentication and CRUD.",
      },
    ],
  },

  mern: {
    title: "Full Stack Web Development (MERN)",
    desc: "Become a MERN Stack Developer by mastering MongoDB, Express.js, React, and Node.js.",
    bannerImg: require("../assets/Mern.png"),
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "📅 Duration: 150+ Hours of Learning",
      "💻 6 Real-world Projects",
      "⚙️ Backend with Node.js & Express",
      "🌐 Frontend with React.js",
      "🎓 Certification upon Completion",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],
    roadmap: [
      {
        title: "Module 1: Frontend with React.js",
        content:
          "React basics, Hooks, Routing, State management, UI libraries.",
      },
      {
        title: "Module 2: Backend with Node.js",
        content: "Express.js, REST APIs, Middleware, JWT Authentication.",
      },
      {
        title: "Module 3: Database",
        content: "MongoDB CRUD, Mongoose ODM, and Atlas integration.",
      },
      {
        title: "Module 4: Deployment",
        content: "Hosting with Render/Netlify, CI/CD pipeline, Docker basics.",
      },
      {
        title: "Capstone Project",
        content:
          "Full Stack MERN project integrating frontend, backend, and database.",
      },
    ],
  },

  uiux: {
    title: "UI/UX Design",
    desc: "Learn user-centered design, prototyping, wireframing, and usability testing with modern tools like Figma and Adobe XD.",
    bannerImg: require("../assets/uiux.jpg"),
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "🎨 Learn Figma, Adobe XD, and Prototyping Tools",
      "📱 Understand Design Systems & Usability",
      "🧠 Master Wireframing & Visual Hierarchy",
      "💡 Real-world UI/UX Projects",
      "🎓 Certification upon Completion",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],
    roadmap: [
      {
        title: "Module 1: Introduction to UI/UX",
        content: "Design Thinking, User Research, Personas, Empathy Mapping.",
      },
      {
        title: "Module 2: Wireframing & Prototyping",
        content: "Low-fidelity and high-fidelity design using Figma.",
      },
      {
        title: "Module 3: Visual Design",
        content: "Typography, Color Theory, Layout Principles, Accessibility.",
      },
      {
        title: "Module 4: Usability Testing",
        content: "User Testing, Feedback, Iterations, Final Presentation.",
      },
    ],
  },

  autocad: {
    title: "AutoCAD",
    desc: "Master 2D drafting and 3D modeling skills for architecture, civil, and mechanical engineering using AutoCAD.",
    bannerImg: require("../assets/Autocad.jpg"),
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "📏 2D Drafting and 3D Modelling",
      "🏗️ Real Engineering Drawings",
      "🧠 Advanced Tools and Layers",
      "📐 Plotting & Dimensioning",
      "🎓 Certificate of Completion",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],
    roadmap: [
      {
        title: "Module 1: Introduction",
        content: "AutoCAD interface, workspace customization, drawing tools.",
      },
      {
        title: "Module 2: 2D Drafting",
        content: "Lines, circles, layers, dimensioning, blocks.",
      },
      {
        title: "Module 3: 3D Modelling",
        content: "Extrusion, surfaces, solid modeling, rendering.",
      },
      {
        title: "Module 4: Project",
        content: "Architectural plan design & mechanical part modeling.",
      },
    ],
  },

  businessanalytics: {
    title: "Business Analytics",
    desc: "Gain practical expertise in analytics, visualization, forecasting, finance insights and decision-making using real-world datasets.",
    bannerImg: require("../assets/businessanalyticscourse.png"),

    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/Cr4DIsz",
    premiumPaymentLink: " https://rzp.io/rzp/GV55TWJ",

    highlights: [
      "📊 Power BI & Excel Dashboards",
      "📈 Statistical Analysis & Insights",
      "🧮 Data Cleaning & Visualization",
      "💼 Real Business Case Studies",
      "🎓 Industry Certification",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],

    roadmap: [
      {
        title: "Module 1: Fundamentals of Business Analytics",
        content: [
          "Understanding Business Analytics",
          "Data Collection Methods",
          "Basics of Data Cleaning",
          "Introduction to Descriptive Analytics",
          "Data Visualization Techniques",
          "Basic Statistical Analysis",
          "Review and Reflection",
        ],
      },
      {
        title: "Module 2: Predictive & Prescriptive Analytics",
        content: [
          "Techniques in Predictive Analytics",
          "Advanced Data Visualization",
          "Prescriptive Analytics Approaches",
          "Machine Learning Basics",
          "Big Data Fundamentals",
          "Tools for Data Analysis",
          "Review and Application",
        ],
      },
      {
        title: "Module 3: Advanced Analytics & Ethics",
        content: [
          "Case Studies in Predictive Analytics",
          "Data Cleaning and Preprocessing",
          "Implementing Machine Learning Models",
          "Exploring Business Simulation",
          "Data Governance and Ethics",
          "Introduction to Cloud Analytics",
          "Reflective Practice and Discussion",
        ],
      },
      {
        title: "Module 4: Advanced Projects & Innovation",
        content: [
          "Advanced Business Analytics Projects",
          "Data Ethics & Regulations",
          "Innovation in Analytics Technologies",
          "Capstone Analytics Project",
          "Peer Review and Feedback",
          "Final Reflections and Exam",
          "Knowledge Integration Day",
        ],
      },
    ],
  },

  dataanalytics: {
    title: "Data Analytics",
    desc: "Analyze and visualize data using Python, SQL, and Tableau to uncover business insights.",
    bannerImg: require("../assets/dataanalytics.jpeg"),
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "📊 Data Cleaning & Transformation",
      "🐍 Python & Pandas for Analysis",
      "🧠 SQL Queries for Insights",
      "📈 Tableau Visualization",
      "🎓 Certification upon Completion",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],
    roadmap: [
      {
        title: "Module 1: Python for Data Analysis",
        content: "NumPy, Pandas, and Data Wrangling.",
      },
      {
        title: "Module 2: SQL Fundamentals",
        content: "Joins, Aggregations, and Subqueries.",
      },
      {
        title: "Module 3: Tableau Visualization",
        content: "Dashboards, KPIs, and Interactive Charts.",
      },
      {
        title: "Capstone Project",
        content: "Create an analytics dashboard using real-world data.",
      },
    ],
  },

  iot: {
    title: "Internet of Things (IoT)",
    desc: "Build IoT systems with sensors, microcontrollers, and cloud integration.",
    bannerImg: require("../assets/java.jpeg"),
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "📟 Arduino & Raspberry Pi Projects",
      "🌐 Cloud Integration (AWS IoT / Blynk)",
      "⚙️ Sensor & Actuator Programming",
      "📡 IoT Communication Protocols",
      "🎓 Certification upon Completion",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],
    roadmap: [
      {
        title: "Module 1: IoT Basics",
        content: "Architecture, components, and communication models.",
      },
      {
        title: "Module 2: Hardware Setup",
        content: "Arduino, Raspberry Pi, and Sensors.",
      },
      {
        title: "Module 3: Cloud Integration",
        content: "IoT data to cloud platforms (AWS/Blynk).",
      },
      {
        title: "Capstone Project",
        content: "Smart Home or IoT monitoring system.",
      },
    ],
  },

  digitalmarketing: {
    title: "Digital Marketing",
    desc: "Digital Marketing is the modern approach to promoting a business online using strategies like SEO, social media, Google Ads, content creation, and email campaigns. It helps businesses increase visibility, attract customers, and drive sales using data-driven techniques.",

    bannerImg: require("../assets/digitalmarketing.jpeg"),

    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/Cr4DIsz",
    premiumPaymentLink: " https://rzp.io/rzp/GV55TWJ",

    highlights: [
      "🌐 SEO, SEM & Google Ads",
      "📱 Social Media Marketing",
      "📝 Content Creation & Strategy",
      "📧 Email Marketing & Automation",
      "📊 Google Analytics & Reporting",
      "🎯 Paid Ads + Targeting",
      "🛒 E-Commerce Marketing",
      "📢 Affiliate & Influencer Marketing",
      "🎨 Canva & Creative Designing",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],

    roadmap: [
  {
    title: "Introduction to Digital Marketing",
    content: [
      "Introduction to Digital Marketing Strategies",
      "Basics of SEO",
      "Using SEO Tools",
      "Introduction to Social Media Marketing",
      "Understanding Email Marketing",
      "Content Marketing Essentials",
      "Review and Reflection",
    ],
  },
  {
    title: "Social Media and Email Marketing",
    content: [
      "Social Media Marketing Platforms",
      "Crafting Email Campaigns",
      "Understanding Content Marketing Metrics",
      "Introduction to PPC Advertising",
      "Setting Up Google Ads",
      "Using Analytics for Digital Campaigns",
      "Review and Application",
    ],
  },
  {
    title: "Advanced Digital Marketing Strategies",
    content: [
      "SEO Case Studies",
      "Advanced Social Media Strategies",
      "Email Marketing Analytics",
      "Video Marketing Essentials",
      "Exploring Affiliate Marketing",
      "Mobile Marketing Techniques",
      "Reflective Practice and Discussion",
    ],
  },
  {
    title: "Strategic Digital Marketing Development",
    content: [
      "Digital Strategy Development",
      "Cross-Channel Marketing Integration",
      "Future Innovations in Digital Marketing",
      "Capstone Digital Marketing Project",
    ],
  },
],

  },

  cloudcomputing: {
    title: "Cloud Computing",
    desc: "Understand AWS, Azure, and Google Cloud for scalable deployment and infrastructure management.",
    bannerImg: require("../assets/cloud.jpeg"),
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "☁️ AWS, Azure & GCP Basics",
      "💻 Virtualization & Storage",
      "🔐 Identity & Access Management",
      "⚙️ CI/CD Deployment Pipelines",
      "🎓 Certification Guidance",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],
    roadmap: [
      {
        title: "Module 1: Introduction to Cloud",
        content: "Virtualization, IaaS, PaaS, SaaS concepts.",
      },
      {
        title: "Module 2: AWS Services",
        content: "EC2, S3, RDS, IAM, and CloudFormation.",
      },
      {
        title: "Module 3: CI/CD",
        content: "Docker, Jenkins, GitHub Actions integration.",
      },
      { title: "Capstone Project", content: "Deploy a full stack app to AWS." },
    ],
  },

  cybersecurity: {
    title: "Cyber Security",
    desc: "Learn ethical hacking, network defense, and data protection techniques.",
    bannerImg: require("../assets/cs.png"),
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "🔐 Ethical Hacking Tools",
      "🧠 Network Security Fundamentals",
      "🧱 Firewalls & IDS/IPS",
      "🧮 Cryptography Basics",
      "🎓 CEH-aligned Curriculum",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],
    roadmap: [
      {
        title: "Module 1: Security Basics",
        content: "Threats, vulnerabilities, and risk management.",
      },
      {
        title: "Module 2: Ethical Hacking",
        content: "Reconnaissance, Scanning, Exploitation.",
      },
      {
        title: "Module 3: Network Defense",
        content: "Firewalls, IDS, VPN, and Wi-Fi Security.",
      },
      {
        title: "Capstone Project",
        content: "Simulate an ethical hack and document mitigation.",
      },
    ],
  },

  dsa: {
    title: "Data Structures & Algorithms",
    desc: "Strengthen problem-solving skills with DSA for coding interviews and computer science fundamentals.",
    bannerImg: require("../assets/dsa.jpg"),
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "💡 Learn with Visualizations",
      "🧮 Master Arrays, Trees, Graphs, DP",
      "⚡ Coding Challenges & Mock Tests",
      "🧠 Interview Preparation",
      "🎓 Certificate of Mastery",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],
    roadmap: [
      {
        title: "Module 1: Basics",
        content: "Complexity analysis, recursion, arrays, linked lists.",
      },
      {
        title: "Module 2: Trees & Graphs",
        content: "BST, DFS, BFS, Topological sort.",
      },
      {
        title: "Module 3: Dynamic Programming",
        content: "Memoization, Tabulation, Classic DP problems.",
      },
      {
        title: "Module 4: Practice",
        content: "LeetCode & Interview question solving.",
      },
    ],
  },

  datascience: {
    title: "Data Science",
    desc: "Use Python, R, and ML techniques to analyze data and build predictive models.",
    bannerImg: require("../assets/datascience.jpg"),
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "📊 Python, R, NumPy, Pandas",
      "🧠 Machine Learning Algorithms",
      "📈 Data Visualization & EDA",
      "🧮 Model Evaluation",
      "🎓 Industry Projects",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],
    roadmap: [
      {
        title: "Module 1: Python for Data Science",
        content: "Data Cleaning, NumPy, Pandas.",
      },
      {
        title: "Module 2: ML Algorithms",
        content: "Regression, Classification, Clustering.",
      },
      {
        title: "Module 3: Visualization",
        content: "Matplotlib, Seaborn, and Power BI integration.",
      },
      {
        title: "Capstone Project",
        content: "Predictive analysis with real datasets.",
      },
    ],
  },

  aiml: {
    title: "AI & Machine Learning",
    desc: "Learn supervised and unsupervised learning, neural networks, and AI model deployment.",
    bannerImg: require("../assets/aiml.jpg"),
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "🤖 Supervised & Unsupervised ML",
      "🧠 Neural Networks & Deep Learning",
      "⚙️ TensorFlow & Scikit-learn",
      "📊 AI Model Deployment",
      "🎓 Industry-grade Projects",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],
    roadmap: [
      {
        title: "Module 1: ML Foundations",
        content: "Supervised vs Unsupervised Learning.",
      },
      {
        title: "Module 2: Deep Learning",
        content: "ANN, CNN, RNN basics with TensorFlow.",
      },
      {
        title: "Module 3: Deployment",
        content: "Streamlit/Flask model hosting, MLOps intro.",
      },
      {
        title: "Capstone Project",
        content: "Build and deploy an AI model end-to-end.",
      },
    ],
  },

  appdevelopment: {
    title: "App Development",
    desc: "Build mobile apps for Android and iOS using React Native and Flutter.",
    bannerImg: require("../assets/appdevelopment.png"),
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "📱 React Native & Flutter",
      "💻 Cross-platform App Development",
      "🔗 API Integration",
      "⚙️ Firebase & Push Notifications",
      "🎓 App Deployment to Play Store",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],
    roadmap: [
      {
        title: "Module 1: React Native Basics",
        content: "Components, Navigation, and Styling.",
      },
      {
        title: "Module 2: Flutter",
        content: "Widgets, Dart language, Layouts.",
      },
      {
        title: "Module 3: APIs & Firebase",
        content: "Real-time DB, Notifications, Auth.",
      },
      { title: "Capstone Project", content: "Publish a working mobile app." },
    ],
  },

  trainingandplacement: {
    title: "Training & Placement Program",
    desc: "A premium career acceleration program covering HR, Business Analytics, Finance, Soft Skills, Interview Skills, Aptitude, and Placement support.",

    bannerImg: require("../assets/TrainingandPlacement.jpg"),

    // Only Premium Plan
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    premiumPaymentLink: "https://rzp.io/rzp/eR1SFrIz",

    highlights: [
      // "📌 Professional HR Skill Training",
      // "📊 Business Analytics Foundations",
      // "💰 Corporate Finance & Investment Basics",
      "🎯 Aptitude Training & Soft Skills Development",
      "🧠 Strategic Thinking & Leadership Skills",
      "🧾 Resume Building + Cover Letter Creation",
      "🎤 Mock Interviews (HR + Technical)",
      "👥 1-on-1 Personalized Mentorship",
      "🎓 Certificate of Completion",
      "🔁 Lifetime Placement Assistance",
      "💻 Paid Internship Opportunity Based on Performance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
      
    ],

    // Everything included — no separate base/premium tier
    premiumExtras: [
      // "💼 Placement Mentorship",
      // "📝 Personalized Resume & Cover Letter Building",
      // "🎤 Mock Interviews + Feedback",
      // "📚 Aptitude Sessions & Communication Training",
      // "👔 Interview Preparation Handbook",
      // "📌 Career Guidance + Portfolio Review",
    ],

    roadmap: [
  {
    title: "Module 1: Written Round Training (Aptitude, Logical Reasoning & Corporate Assessments)",
    content: [
      "Quantitative Aptitude",
      "Logical Reasoning",
      "Data Interpretation",
      "Verbal Ability",
      "Corporate Written Rounds",
      "Assessment Practice",
    ],
  },

  {
    title: "Module 2: Soft Skill Development",
    content: [
      "Communication Skills",
      "Professional Etiquette",
      "Presentation Skills",
      "Teamwork & Collaboration",
      "Problem-Solving Attitude",
      "Emotional Intelligence",
    ],
  },

  {
    title: "Module 3: Resume Building & LinkedIn Optimization",
    content: [
      "Resume Writing Basics",
      "Highlighting Skills & Projects",
      "Job Profile Mapping",
      "Cover Letter Crafting",
      "Portfolio & LinkedIn",
      "Resume Review",
    ],
  },

  {
    title: "Module 4: HR Mock Interview Preparation",
    content: [
      "Interview Fundamentals",
      "Common HR Questions",
      "Behavioral Interview Prep",
      "Handling Difficult Questions",
      "Mock Interviews",
      "Final Placement Readiness",
    ],
  },
],

  },

  aptitude: {
    title: "Aptitude Training",
    desc: "Develop strong problem-solving and analytical skills for competitive exams and placement tests.",
    bannerImg: "https://cdn-icons-png.flaticon.com/512/4149/4149678.png",

    // Pricing
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "➗ Quantitative Aptitude Basics",
      "📐 Logical Reasoning",
      "🧮 Arithmetic & Number Systems",
      "📊 Data Interpretation",
      "🤔 Problem-Solving Techniques",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],

    premiumExtras: [
      "🔢 Advanced Aptitude Tricks",
      "⏱️ Speed & Accuracy Training",
      "📘 Placement Aptitude Mock Tests",
      "💡 Advanced Puzzles & Reasoning Sets",
    ],

    roadmap: [
      {
        title: "Module 1: Quant Basics",
        content: "Percentages, ratios, averages, simplification.",
      },
      {
        title: "Module 2: Reasoning",
        content: "Blood relations, coding-decoding, seating arrangements.",
      },
      {
        title: "Module 3: Data Interpretation",
        content: "Graphs, tables, charts, caselets.",
      },
      {
        title: "Module 4: Mock Tests",
        content:
          "Timed aptitude practice tests with full analysis & mentoring.",
      },
    ],
  },

  softskills: {
    title: "Soft Skills Training",
    desc: "Improve communication, teamwork, leadership, and professional etiquette for career excellence.",
    bannerImg: "https://cdn-icons-png.flaticon.com/512/4333/4333609.png",

    // Pricing
    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/SOCL1aVD",
    premiumPaymentLink: " https://rzp.io/rzp/eyKLvBD",

    highlights: [
      "🗣️ Effective Communication",
      "🤝 Teamwork & Collaboration",
      "🎯 Goal Setting & Planning",
      "😃 Personality Development",
      "💬 Presentation Skills",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
    ],

    premiumExtras: [
      "👨‍🏫 1-on-1 Coaching Sessions",
      "📚 Advanced Public Speaking",
      "🧠 Leadership Development",
      "📝 Personalized Skill Assessment",
    ],

    roadmap: [
      {
        title: "Module 1: Communication Skills",
        content: "Verbal skills, listening skills, professional speaking.",
      },
      {
        title: "Module 2: Personality Development",
        content: "Confidence building, attitude improvement, grooming.",
      },
      {
        title: "Module 3: Workplace Skills",
        content: "Teamwork, leadership, time management.",
      },
      {
        title: "Module 4: Presentations",
        content:
          "Public speaking sessions, presentation structure, confidence practice.",
      },
    ],
  },

  humanresource: {
    title: "Human Resource Management",
    desc: "Build skills in HR operations, recruitment, performance management, analytics, corporate culture and HR strategic leadership.",
    bannerImg: require("../assets/humanresourcescourse.jpg"),

    baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/Cr4DIsz",
    premiumPaymentLink: " https://rzp.io/rzp/GV55TWJ",

    highlights: [
      "👥 Talent Acquisition & Hiring Skills",
      "📌 HR Documentation & Policy Training",
      "📊 HR Analytics Basics",
      "🤝 Corporate Etiquette, Training & Development",
      "🎓 Certification upon Completion",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],

    roadmap: [
      {
        title: "Module 1: Introduction to HR Management",
        content: [
          "Introduction to HR Management",
          "Employment Law Basics",
          "Ethics in HR Practices",
          "Overview of Talent Acquisition",
          "Fundamentals of Performance Management",
          "Learning & Development Concepts",
          "Review and Reflection",
        ],
      },
      {
        title: "Module 2: Advanced HR Practices",
        content: [
          "Advanced Recruitment Techniques",
          "Employee Retention Strategies",
          "Measuring Performance Effectively",
          "Creating Effective Training Programs",
          "Compensation & Benefits Structures",
          "Utilizing HR Technologies",
          "Review and Application",
        ],
      },
      {
        title: "Module 3: Specialized HR Topics",
        content: [
          "Case Studies in HR Management",
          "Introduction to HR Analytics",
          "Conflict Resolution Techniques",
          "Designing Organizational Culture",
          "Change Management in HR",
          "Strategic HR Planning",
          "Reflective Practice and Discussion",
        ],
      },
      {
        title: "Module 4: Strategic HR & Business",
        content: [
          "Integrated HR Technologies",
          "Future Trends in HR",
          "Capstone HR Project",
          "Peer Review and Feedback",
          "Final Reflections and Exam",
          "Knowledge Integration Day",
        ],
      },
    ],
  },

  finance: {
    title: "Corporate & Strategic Finance",
    desc: "Learn modern financial principles, investment analysis, forecasting, risk management, fintech trends and corporate finance.",
    bannerImg: require("../assets/Finance.jpg"),

   baseOldPrice: "7999",
    baseNewPrice: "₹3999",

    premiumOldPrice: "₹14999",
    premiumNewPrice: "₹6999",

    basePaymentLink: "https://rzp.io/rzp/Cr4DIsz",
    premiumPaymentLink: " https://rzp.io/rzp/GV55TWJ",

    highlights: [
      "📊 Practical Finance Skills",
      "💰 Corporate & Personal Finance",
      "📈 Investment & Risk Analysis",
      "🧮 Financial Modeling & Forecasting",
      "🎓 Certification and Case Studies",
      "🧾 Resume Building & Mock Interviews",
      "💻 Guaranteed paid internship with stipend based on your performance",
      "🎓 Lifetime placement assistance",
      "🎯 Personalized Placement Training",
    "💼 Industry Mentorship",
    "🧠  ATS & Linkedin Optimization",
    ],

    roadmap: [
      {
        title: "Module 1: Financial Fundamentals",
        content: [
          "Basics of Financial Statements",
          "Corporate Finance Principles",
          "Types of Investments",
          "Financial Markets Overview",
          "Introduction to Risk Management",
          "Basics of Financial Modeling",
          "Review and Reflection",
        ],
      },
      {
        title: "Module 2: Advanced Financial Analysis & Case Studies",
        content: [
          "Detailed Corporate Finance Case Studies",
          "Advanced Investment Analysis",
          "Exploring Financial Instruments",
          "Risk Management Tools",
          "Building Complex Financial Models",
          "Budgeting & Forecasting Techniques",
          "Review and Application",
        ],
      },
      {
        title: "Module 3: Strategic & Global Finance",
        content: [
          "Investment Strategies Case Studies",
          "Advanced Risk Management Techniques",
          "International Finance Basics",
          "Personal Finance Management",
          "Financial Decision-Making Models",
          "Exploring Fintech Innovations",
          "Reflective Practice and Discussion",
        ],
      },
      {
        title: "Module 4: Strategic Finance & Innovation",
        content: [
          "Strategic Financial Management",
          "Innovations in Financial Services",
          "The Future of Finance",
          "Capstone Finance Project",
          "Peer Review and Feedback",
          "Final Reflections and Exam",
          "Knowledge Integration Day",
        ],
      },
    ],
  },
};

// ===================================
// Component
// ===================================

function CourseDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const course = courseData[slug?.toLowerCase()];
  const isSingleModel = slug?.toLowerCase() === "trainingandplacement"; // <-- key condition

  if (!course) {
    return (
      <Container className="text-center py-5">
        <h2>Course Not Found</h2>
        <Button variant="primary" onClick={() => navigate("/courses")}>
          Back to Courses
        </Button>
      </Container>
    );
  }

  const baseHighlights = course.highlights || [];

  const premiumExtras = [
    // "🎯 Personalized Placement Training",
    // "💼 Industry Mentorship",
    // "🧠  ATS & Linkedin Optimization",
  ];

  const combinedPremium = Array.from(
    new Set([...baseHighlights, ...premiumExtras])
  );

  return (
    <div className="course-detail-page">
      {/* ===== Banner ===== */}
      <div className="banner">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <h2 className="banner-title">{course.title}</h2>
              <p className="banner-desc">{course.desc}</p>
            </Col>
            <Col md={6}>
              <img
                src={course.bannerImg}
                alt={course.title}
                className="banner-img"
              />
            </Col>
          </Row>
        </Container>
      </div>

      {/* ===== Main Content ===== */}
      <Container className="py-5">
        <div className="course-content">
          {/* Left – Roadmap */}
          <div className="roadmap-section">
            <div className="panel">
              <h4 className="panel-title text-center mb-3">Course Roadmap</h4>
              <Accordion>
                {course.roadmap.map((r, i) => (
                  <Accordion.Item key={i} eventKey={String(i)}>
                    <Accordion.Header>{r.title}</Accordion.Header>
                    <Accordion.Body>
  <ul>
    {(Array.isArray(r.content)
      ? r.content
      : r.content.split(/[,.\n]/)  // split by comma, period, or newline
    )
      .map((line) => line.trim())
      .filter((line) => line.length > 0)  // remove empty strings
      .map((line, idx) => (
        <li key={idx}>{line}</li>
      ))}
  </ul>
</Accordion.Body>

                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </div>

          {/* Right – Highlights & Price */}
          {/* Right – Highlights & Price */}
          <div
            className={`highlights-section ${
              isSingleModel ? "single-model" : ""
            }`}
          >
            {/* ================= BASE MODEL (hidden for interviewtraining) ================= */}
            {!isSingleModel && (
              <div className="highlight-card">
                <h4 className="panel-title"> Domestic Training Program</h4>

                <ul className="highlights-list">
                  {/* base features */}
                  {baseHighlights.map((h, i) => (
                    <li key={i} className="highlight-item">
                      <span
                        className="highlight-icon"
                        style={{ color: "green" }}
                      >
                        ✔
                      </span>
                      <span className="highlight-text">{h}</span>
                    </li>
                  ))}

                  {/* excluded features */}
                  {premiumExtras.map((h, i) => (
                    <li key={"e-" + i} className="highlight-item">
                      <span className="highlight-icon" style={{ color: "red" }}>
                        ✘
                      </span>
                      <span className="highlight-text">{h}</span>
                    </li>
                  ))}
                </ul>

                {/* Base price */}
                <div className="course-price" style={{ marginTop: 10 }}>
                  <span className="old-price">{course.baseOldPrice}</span>
                  &nbsp;
                  <span className="new-price">{course.baseNewPrice}</span>
                </div>

                {/* Base payment button */}
                <div style={{ marginTop: 14 }}>
                  <button
                    className="enroll-btn"
                    onClick={() =>
                      window.open(course.basePaymentLink, "_blank")
                    }
                  >
                    Enroll Now
                  </button>
                </div>
              </div>
            )}

            {/* ================= PREMIUM MODEL — works for all ================= */}
            <div className="highlight-card premium-card">
              <h4 className="panel-title">
                {isSingleModel ? "Training Program Benefits based on Indian companies" : "International Training Program"}
              </h4>

              <ul className="highlights-list">
                {combinedPremium.map((h, i) => (
                  <li key={i} className="highlight-item">
                    <span className="highlight-icon" style={{ color: "green" }}>
                      ✔
                    </span>
                    <span className="highlight-text">{h}</span>
                  </li>
                ))}
              </ul>

              {/* Premium pricing logic */}
              <div className="course-price" style={{ marginTop: 10 }}>
  <span className="old-price">
    {isSingleModel ? course.premiumOldPrice : course.premiumOldPrice}
  </span>
  &nbsp;
  <span className="new-price">
    {isSingleModel ? course.premiumNewPrice : course.premiumNewPrice}
  </span>
</div>


              {/* Premium button */}
              <div className="enroll-btn-container" style={{ marginTop: 14 }}>
                <button
                  className="enroll-btn"
                  onClick={() =>
                    window.open(course.premiumPaymentLink, "_blank")
                  }
                >
                  Enroll Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </Container>

      {/* CTA */}
      <div className="text-center pb-5">
        <Button
          variant="success"
          size="lg"
          onClick={() => navigate("/courses")}
        >
          Explore More Courses
        </Button>
      </div>
    </div>
  );
}

export default CourseDetail;
